module.exports = __webpack_public_path__ + "img/broadcast-test-icon5.cc015700.png";